<template>
    <div v-loading="tableLoading">
        <div style="margin-top: 20px;">
            <el-row :gutter="12">
                <el-col :span="8">
                    <el-button type="primary" @click="openAddDialog()">新建地址</el-button>
                </el-col>
                <el-col :span="16" style="text-align: right;">
                    <el-select style="width: 110px;margin-left: 3px;" v-model="selectValue" placeholder="请选择">
                        <el-option label="联系人" value="1"></el-option>
                        <el-option label="手机" value="2"></el-option>
                    </el-select>
                    <el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" placeholder="请输入"></el-input>
                    <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 10px;">
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                element-loading-text="数据正在加载中"
                @selection-change="handleSelectionChange"
                :header-cell-style="headClass"
                :row-style="rowClass"
            >
                <el-table-column prop="consignee" label="收货人"></el-table-column>
                <el-table-column prop="phone" label="电话/手机"></el-table-column>
                <el-table-column prop="location" label="收货地址"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="openUpdateDialog(scope.row)">编辑</button>
                        <button @click="del(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <el-dialog :title="curTitle" :visible.sync="myDialog" :close-on-click-modal="false">
            <div>
                <div>
                    <span>收件人</span>
                    <el-input type="text" v-model="consignee" style="width: 217px;margin-left: 50px;"></el-input>
                </div>
                <div style="margin-top: 15px;">
                    <span>手机号</span>
                    <el-input type="text" v-model="phone" style="width: 217px;margin-left: 50px;"></el-input>
                </div>
                <div style="margin-top: 15px;">
                    <span>收件地址</span>
                    <el-input type="text" v-model="location" style="width: 217px;margin-left: 36px;"></el-input>
                </div>
                <div style="margin-top: 25px;margin-left: 92px;">
                    <el-button type="primary" :loading="commitLoading" @click="newAddress">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    components: {},
    mounted() {
        this.updateTable();
    },
    data() {
        return {
            commitLoading: false,
            tableLoading: false,
            selectValue: '',
            queryValue: '',
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            myDialog: false,
            phone: '',
            consignee: '',
            location: '',
            curTitle: '',
            addressId: 0
        };
    },
    computed: {},
    watch: {},
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.updateTable()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.updateTable()
        },
        rowClass({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return 'background:#F1F2F7;'
            } else {
                return 'background:white;'
            }
            return ''
        },
        headClass({ row, rowIndex }) {
            if (rowIndex == 0) {
                return ''
            }
            return ''
        },
        openAddDialog() {
            this.addressId = 0;
            this.consignee = "";
            this.location = "";
            this.phone = "";
            this.myDialog = true;
            this.curTitle = "新增地址";
        },
        openUpdateDialog(address) {
            this.addressId = address.addressId;
            this.consignee = address.consignee;
            this.location = address.location;
            this.phone = address.phone;
            this.myDialog = true;
            this.curTitle = "修改地址";
        },
        del(address) {
            var thiz = this;
            this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios.get(this.$store.getters.getApiValue + "/srsAddress/delAddress.do", {
                    params: {
                        addressId: address.addressId
                    }
                }).then(function (response) {
                    var data = response.data;
                    if (data.status == "200") {
                        if (data.data) {
                            thiz.updateTable();
                        } else {
                            thiz.$message.error("操作失败");
                        }
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function (error) {
                    thiz.$message.error("系统异常,请与管理员联系!");
                })
            }).catch(() => {

            });
        },
        newAddress() {
            this.commitLoading = true;
            var thiz = this;
            var url = "/srsAddress/addAddress.do";
            if (this.addressId != 0) {
                url = "/srsAddress/updateAddress.do"
            }
            axios.get(this.$store.getters.getApiValue + url, {
                params: {
                    consignee: this.consignee,
                    location: this.location,
                    phone: this.phone,
                    addressId: this.addressId
                }
            }).then(function (response) {
                var data = response.data;
                if (data.status == "200") {
                    if (data.data) {
                        thiz.updateTable();
                        thiz.myDialog = false;
                    } else {
                        thiz.$message.error("操作失败");
                    }
                } else {
                    thiz.$message.error(data.message);
                }
            }).catch(function (error) {
                thiz.$message.error("系统异常,请与管理员联系!");
            }).finally(() => {
                this.commitLoading = false
            });
        },
        updateTable() {
            this.tableLoading = true;
            var thiz = this
            var params = {
                pageId: this.currentPage,
                size: this.pageSize
            }
            if (this.selectValue != '') {
                if (this.selectValue == '1' && this.queryValue != '') {
                    params.consignee = this.queryValue
                } else if (this.selectValue == '2' && this.queryValue != '') {
                    params.phone = this.queryValue
                }
            }
            axios
                .get(this.$store.getters.getApiValue + 'srsAddress/getAddressList.do', {
                    params: params
                })
                .then(function (response) {
                    var data = response.data
                    if (data.status == '200') {
                        thiz.total = data.totalCount
                        thiz.tableData = data.data
                    } else {
                        thiz.$message.error(data.message)
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    thiz.$message.error('系统异常!请与管理员联系!')
                })
                .finally(() => {
                    this.tableLoading = false
                })
        }
    }
}
</script>
<style scoped>
</style>